<template>
  <div class="poi-wrapper">
    <div class="close-button" @click="goBack">
      <img src="../../assets/icons/cancel-24px.png" alt="close" />
    </div>
    <!-- <div id="poi-data" v-if="poiData" :class="{expanded: showMore}"> -->
      <div
        id="poi-data"
        v-if="poiData && !showRoutingMap"
        :class="{ expanded: showMore }"
        :aria-hidden="showRoutingMap ? 'true' : 'false'"
      >
      <div class="cover-wrapper">
        <div class="cover" v-if="rotator.length > 0" :style="getCoverBackground()">
          <link rel="prefetch" as="image" v-for="img in rotator" :key="img" :href="hostAddress + img" />
          <img class="cover-img" :src="hostAddress + rotator[selected]" />
          <img class="cover-logo" v-if="poiData.logo" :src="hostAddress + poiData.logo" alt="logo" />
          <div class="arrowbox back" v-if="rotator.length > 1" @click="selected = (selected + 1) % rotator.length">
            <span class="material-icons-round">arrow_back_ios</span>
          </div>
          <div
            class="arrowbox forward"
            v-if="rotator.length > 1"
            @click="selected = (selected + rotator.length - 1) % rotator.length"
          >
            <span class="material-icons-round">arrow_forward_ios</span>
          </div>
        </div>
        <div class="poi-infos">
          <div class="poi-intro">
            <!-- <div class="poi-name">{{ poiData.name }}</div> -->
            <!-- buton fly  -->
            <div class="poi-header">
              <!-- ZONA 70%: NAME -->
              <div class="poi-name" :title="poiData.name">
                {{ poiData.name }}
              </div>
              <!--  30%: BUTTONS -->
              <div class="poi-actions">

                <button
                  v-if="isPointGeometry && !showRoutingMap"
                  class="action-btn"
                  :title="$t('buttons.routing')"
                  @click="onRoutingClick"
                  aria-label="Routing"
                >
                  <img
                    src="@/assets/icons/routing.png"
                    alt=""
                    class="action-icon"
                  />
                  <span class="action-text"></span>
                </button>


                <div
                  v-if="isLineGeometry"
                  ref="flightControlContainer"
                  class="flight-control-mount"
                  aria-hidden="true"
                ></div>
              </div>
            </div>
            <div class="poi-address" v-if="poiData.address">
              {{ poiData.address[0] }}
            </div>
            <div class="poi-address" v-if="poiData.address">
              {{ poiData.address[1] }}
            </div>
            <div
              class="is-open-info"
              :class="{open: isOpened, expanded: isDesktop() || showMore}"
              v-if="poiData.opening_hours"
            >
              <i class="material-icons-round md-15 white">schedule</i>
              {{ isOpened ? $t("poiDetails.opened") : $t("poiDetails.closed") }}
            </div>
            <div class="poi-links" :class="{expanded: isDesktop() || showMore}">
              <div class="poi-link" v-if="poiData.contact.tel1">
                <a :href="'tel:' + poiData.contact.tel1">{{ poiData.contact.tel1 }}</a>
              </div>
              <div class="poi-link" v-if="poiData.contact.mail">
                <a :href="'mailto:' + poiData.contact.mail">{{ poiData.contact.mail }}</a>
              </div>
              <div
                class="poi-link"
                v-if="poiData.contact.website && !poiData.contact.website.includes('outdooractive')"
              >
                <a :href="poiData.contact.website" target="_blank">{{ websiteDisplay }}</a>
              </div>
            </div>
            <div class="attribution-info" v-if="poiData.attribution">
              <span>{{ $t("poiDetails.content") }} &copy; </span>
              <span v-html="poiData.attribution"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="more-infos-wrapper">
        <div ref="elevationContainer" 
              class="height-profile"   
              v-if="isLineGeometry" 
              :style="{ display: isWeatherMapActive ? 'block' : 'none' }"
              style="width: 100%; height: 110px;">
          </div>
        <div
          class="more-info"
          :class="{expanded: showMore}"
          v-show="poiData.opening_hours || poiData.long_info || elevations"
        >
          <!-- <div class="export-buttons" v-if="elevations">
            <a @click="exportTrack('gpx')">GPX</a>
            <a @click="exportTrack('geojson')">GeoJSON</a>
          </div> -->
          <!-- aici avem elevation in expanded:showMore-->
          <!-- <div ref="elevationContainer" 
              class="height-profile"   
              v-if="isLineGeometry" 
              :style="{ display: isWeatherMapActive ? 'block' : 'none' }"
              style="width: 100%; height: 110px;">
          </div> -->
          <!-- <div id="height-profile">
            <img
              v-if="elevationProfileImage"
              :src="elevationProfileImage"
              alt="Elevation Profile"
              :style="{ display: !isWeatherMapActive ? 'block' : 'none' }"
              style="max-width: 100%"
            />
          </div>  -->

          <div class="opening-schedule" v-if="poiData.opening_hours">
            <div class="time-info">{{ $t("poiDetails.openingHours") }}</div>
            <table class="opening-schedule">
              <tr class="working-days" v-for="day in weekDays" :key="day.id">
                <td>{{ $t("general." + day.toLowerCase()) }}</td>
                <td v-if="poiData.opening_hours[day].length > 0">
                  <div v-for="op in poiData.opening_hours[day]" :key="op[0]">{{ op[0] }} - {{ op[1] }}</div>
                </td>
                <td v-else>{{ $t("poiDetails.closed") }}</td>
              </tr>
            </table>
          </div>
          <div v-if="poiData.long_info">
            <div class="time-info">{{ $t("poiDetails.moreInfo") }}</div>
            <div class="additional-info" v-html="poiData.long_info"></div>
          </div>
        </div>
        <div
          v-if="
            poiData.opening_hours ||
            poiData.long_info ||
            elevations ||
            poiData.contact.website ||
            poiData.contact.tel1 ||
            poiData.contact.mail
          "
          class="addit-info"
          @click="showMore = !showMore"
        >
          {{ showMore ? $t("poiDetails.showLess") : $t("poiDetails.showMore") }}
        </div>
      </div>
    </div>
    <MapRouting
  v-if="showRoutingMap"
  :initialLat="initialLatFromPOI"
  :initialLng="initialLngFromPOI"
  :initialZoom="16"
  :end="{ lat: poiStop.lat, lng: poiStop.lng }"
  @close="onRoutingClose"  
/>

  </div>
</template>
<script>
import Vue from "vue";
import CategoryService from "@/services/category";
import M2wApi from "@/services/m2w_api";
import {basemap} from "@/services/map/basemap";
import {googleMaps} from "@/services/map/googleMaps";
import LineString from "ol/geom/LineString";
import Profil from "ol-ext/control/Profile";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Feature from "ol/Feature";
// import Point from "ol/geom/Point";
// import CircleStyle from "ol/style/Circle";
// import Stroke from "ol/style/Stroke";
import GPX from "ol/format/GPX";
import GeoJSON from "ol/format/GeoJSON";
import MapRouting from "@/components/MapRoutingMTK.vue"; 


export default {
  name: "PoiDetails",
  //components: {Carousel, Slide},
  components: { MapRouting, },

  data() {
    return {
      weekDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      hostAddress: M2wApi.host_address,
      poiData: null,
      showMore: this.isDesktop(),
      prevRoute: null,
      elevations: null,
      coverLoaded: false,
      selected: 0,
      elevationProfileImage: null,
      elevationProfileSvg: null,
      isFlying: false,
      isPaused: false,

      showRoutingMap: false,
      initialLatFromPOI: null,
      initialLngFromPOI: null,
      poiStop: null,

    };
  },
  computed: {
    isOpened: function () {
      return CategoryService.checkIfOpened(this.poiData);
    },
    openingHours: function () {
      return this.poiData.opening_hours;
    },
    parent: function () {
      return this.$route.query.parent;
    },
    websiteDisplay: function () {
      if (this.poiData.contact.web_label) return this.poiData.contact.web_label;

      let matches = this.poiData.contact.website.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
      if (matches) return matches[1];
      return "";
    },
    rotator: function () {
      let tmp = [...this.poiData.gallery];
      if (this.poiData.cover) tmp.unshift(this.poiData.cover);
      return tmp;
    },
    isWeatherMapActive() {
      return this.$root.weatherActive === true;
    },
    isLineGeometry() {
      return (
        this.poiData &&
        this.poiData.geom &&
        (this.poiData.geom.type === "LineString" || this.poiData.geom.type === "MultiLineString")
      );
    },
    isPointGeometry() {
      return this.poiData && this.poiData.geom && 
        (this.poiData.geom.type === "Point" || this.poiData.geom.type === "MultiPoint");
    }
    ,
     showFlyButton() {
    return this.isLineGeometry && this.$root.weatherActive;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },

  watch: {
    "$route.params.id": async function (id, oldId) {
      if (id && parseInt(id) !== oldId)
        await this.fetchFromApi();
    },

    "$i18n.locale": async function () {
      await this.fetchFromApi();
    },

    //nou26.01
    poiData: {
      immediate: true,
      handler() {
        this.emitMtkHostsIfReady();
      }
    },
    isWeatherMapActive() {
      this.emitMtkHostsIfReady();
    },
    showMore() {
      this.$nextTick(this.emitMtkHostsIfReady);
    }


  },

  async mounted() {
    // this.$root.$emit("focusMapAfterAdding", this.poiData);
    this.$root.$on("mtkElevationProfileReady", this.onElevationProfileSvgReady);
    // this.$root.$on("mtkFlightControlReady", this.onFlightControlReady);

    this.$root.$on("flightFinished", () => {
      this.isFlying = false;
      this.isPaused = false;
    });

    this.$root.$on("mtkFlightControlReady", (flightDiv) => {
      const target = this.$refs.flightControlContainer;
      if (target && flightDiv) {
        target.innerHTML = "";
        target.appendChild(flightDiv);
      }
    });
    
    await this.fetchFromApi();
  },

  deactivated() {
    this.$layers.teardownSinglePoi(this.poiData);
    this.poiData = null;
    this.cleanUpHeightProfile();
  },

  beforeDestroy() {
    this.closeFlight();
    this.$root.$off("mtkElevationProfileReady", this.onElevationProfileSvgReady);
    this.$layers.teardownSinglePoi(this.poiData);
    this.poiData = null;
    this.cleanUpHeightProfile();
    this.$root.$off("flightFinished");
    this.$root.$off("focusMapAfterAdding"); 
  },

  methods: {
    //nou26.01
    emitMtkHostsIfReady() {
    if (!this.isWeatherMapActive) return;

    this.$nextTick(() => {

      if (this.isLineGeometry && this.$refs.elevationContainer) {
        this.$root.$emit("mtkElevationHostReady", this.$refs.elevationContainer);
      }
      if (this.isLineGeometry && this.$refs.flightControlContainer) {
        this.$root.$emit("mtkFlightHostReady", this.$refs.flightControlContainer);
      }
      this.$root.$emit("mtkUiHostsReady");
    });
  },
  onFlightControlReady(buttonEl) {
    const host = this.$refs.flightControlContainer;
    if (!host || !buttonEl) return;
    host.innerHTML = "";
    host.appendChild(buttonEl);
  },
    // onRoutingClick(e) {
    //   e?.stopPropagation?.();

    //   const g = this.poiData?.geom;
    //   if (!g) return;

    //   let c = null;
    //   if (g.type === "Point") c = g.coordinates;
    //   else if (g.type === "MultiPoint" && g.coordinates?.length) c = g.coordinates[0];
    //   if (!c) return;

    //   // EPSG:3857 vs lat/lng
    //   const looksLikeMerc = Math.abs(c[0]) > 180 || Math.abs(c[1]) > 90;
    //   const ll = looksLikeMerc
    //     ? googleMaps.transformToLatLngLiteral(c)  
    //     : { lat: c[1], lng: c[0] };

    //   this.poiStart = { lat: ll.lat, lng: ll.lng };
    //   this.initialLatFromPOI = ll.lat;
    //   this.initialLngFromPOI = ll.lng;
      
    //   this.showRoutingMap = true;
    //   document.body.classList.add('routing-active');
    // },

    onRoutingClick(e) {
      e?.stopPropagation?.();

      const g = this.poiData?.geom;
      if (!g) return;

      let c = null;
      if (g.type === "Point") c = g.coordinates;
      else if (g.type === "MultiPoint" && g.coordinates?.length) c = g.coordinates[0];
      if (!c) return;

      // EPSG:3857 vs lat/lng
      const looksLikeMerc = Math.abs(c[0]) > 180 || Math.abs(c[1]) > 90;
      const ll = looksLikeMerc
        ? googleMaps.transformToLatLngLiteral(c)  
        : { lat: c[1], lng: c[0] };

      // this.poiStart = { lat: ll.lat, lng: ll.lng };
      this.poiStop = { lat: ll.lat, lng: ll.lng };
      this.initialLatFromPOI = ll.lat;
      this.initialLngFromPOI = ll.lng;
      
      this.showRoutingMap = true;
      document.body.classList.add('routing-active');
    },

    onRoutingClose() {
      this.showRoutingMap = false;
      this.poiStop = null;
      this.$root.$emit('routingStatus', { isRoutingActive: false }); 
      document.body.classList.remove('routing-active');
    },
    
    async fetchFromApi() {
      this.$layers.teardownSinglePoi(this.poiData);
      this.poiData = null;
      const id = this.$route.params.id;
      this.poiData = await M2wApi.get_single_poi(id, this.$i18n.locale, this.parent);
      await this.showOnMap();
      this.loadElevation();
    },

    async showOnMap(){
      let extent = await this.$layers.setupSinglePoi(this.poiData);
      basemap.map.getView().fit(extent, {duration: 500, minResolution: 1});
      this.$root.$emit("focusMapAfterAdding", this.poiData);
    },
    
    // async goBack() {
    //   this.closeFlight();
    //   if (this.parent) {
    //     await this.$router.push({name: "pois", query: {...this.$route.query, "toc-id": this.parent}});
    //   } else if (this.prevRoute.name != null) {
    //     this.$router.go(-1);
    //   } else {
    //     await this.$router.push({name: "default"});
    //   }
    // },
    async goBack() {
      this.closeFlight();

      const is3D = this.$route.fullPath.includes("mtk=1");
      if (this.parent) {
        await this.$router.push({
          name: "pois",
          query: { 
            ...this.$route.query, 
            "toc-id": this.parent, 
            ...(is3D ? { mtk: "1" } : {}) 
          }
        });
        console.log("[goBack] revenire la categorie", is3D ? "(3D)" : "(OL)");
        return;
      }
      if (this.prevRoute) {
        const prevIs3D = this.prevRoute.fullPath?.includes("mtk=1");
        if (prevIs3D !== is3D) {
          await this.$router.push({
            name: "pois",
            query: { 
              ...this.$route.query, 
              ...(is3D ? { mtk: "1" } : {}) 
            }
          });
          return;
        }
        this.$router.go(-1);
        return;
      }
      const defaultView = Vue.config.project.default_view || "/";
      await this.$router.push({
        path: defaultView,
        query: { 
          ...this.$route.query, 
          ...(is3D ? { mtk: "1" } : {}) 
        }
      });
    },
    async loadElevation() {

      if (!this.poiData.geom.type.includes("LineString")) {
        return;
      }

      if (!this.poiData.parent.show_profile) {
        return;
      }

      let coordinates = this.poiData.geom.coordinates;
      if (this.poiData.geom.type === "MultiLineString") {
        coordinates = [].concat(...coordinates);
      }

      if (this.isWeatherMapActive) {
        this.$root.$emit("startElevationProfileMTK", coordinates);
        return;
      }

      let path = new LineString(coordinates);
      let gpath = path.getCoordinates().map((c) => googleMaps.transformToLatLngLiteral(c));
      try {
        const elevationData = await this.getElevationsInChunks(gpath);
        console.log("Elevation data loaded from Google:", elevationData.length, "points");
        this.plotElevationOL(elevationData);
      } catch (error) {
        console.error("Elevation query failed:", error);
      }
    },

    plotElevationOL(elevations) {

      this.elevations = elevations.map((e) => {
        let transformed = googleMaps.transformFromLatLng(e.location);
        return [transformed[0], transformed[1], Math.round(e.elevation)];
      });

      let geometry = new LineString(this.elevations);
      this.cleanUpHeightProfile();

      this.profile = new Profil({
        target: document.querySelector("#height-profile"),
        style: new Style({
          fill: new Fill({ color: "#ccc" }),
        }),
        info: {
          altitude: this.$t("poiDetails.altitude"),
          zmin: this.$t("poiDetails.zmin"),
          zmax: this.$t("poiDetails.zmax"),
          distance: this.$t("poiDetails.distance"),
          time: this.$t("poiDetails.time"),
          ytitle: this.$t("poiDetails.altitude") + " (m)",
          xtitle: this.$t("poiDetails.distance") + " (km)",
        },
        width: 275,
        height: 190,
      });

      basemap.map.addControl(this.profile);
      this.profile.setGeometry(geometry);
    },

    cleanUpHeightProfile() {
      let elem = document.querySelector("#height-profile");
      if (elem) elem.innerHTML = "";
    },

    exportTrack(format) {
      let coords = this.poiData.geom.coordinates;
      if (this.poiData.geom.type === "MultiLineString") coords = Array.prototype.concat(...coords);
      let ls = new LineString(coords);
      let feature = new Feature(ls.simplify(0.5));
      let outputString;
      let options = {
        featureProjection: "EPSG:3857",
      };

      if (format === "gpx") outputString = new GPX().writeFeatures([feature], options);
      else if (format === "geojson") outputString = new GeoJSON().writeFeatures([feature], options);
      else return;

      let element = document.createElement("a");
      element.setAttribute("href", "data:application/gpx+xml;charset=utf-8," + encodeURIComponent(outputString));
      if (format === "gpx") element.setAttribute("download", "track.gpx");
      else element.setAttribute("download", "track.geojson");

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    isDesktop() {
      if (screen.width >= 600) {
        return true;
      } else {
        return false;
      }
    },
    getCoverBackground() {
      const color =
        this.poiData?.style?.fill_color ??
        this.poiData?.parent?.style?.fill_color ??
        null;

      const result = color ? { 'background-color': color } : '';
      return result;
    },
    // async getElevationsInChunks(gpath, chunkSize = 200) {
    //   const elevator = new window.google.maps.ElevationService();
    //   let allResults = [];

    //   for (let i = 0; i < gpath.length; i += chunkSize) {
    //     const chunk = gpath.slice(i, i + chunkSize);
    //     const result = await new Promise((resolve, reject) => {
    //       elevator.getElevationForLocations({locations: chunk}, (res, status) => {
    //         if (status === "OK") resolve(res);
    //         else reject(status);
    //       });
    //     });
    //     allResults.push(...result);
    //   }

    //   return allResults;
    // },
    onElevationProfileSvgReady(profileElement) {
      const container = this.$refs.elevationContainer;
      if (!container) {
        console.warn("Container .height-profile container not foundt");
        return;
      }
      container.innerHTML = "";
      container.appendChild(profileElement);
      console.log("Moved original DOM into container")

        // Emit către WeatherMTK.vue
      // this.$root.$emit("elevationProfileReady", profileElement);
    },

    // onFlightControlReady(buttonElement) {
    //   const container = this.$refs.flightControlContainer;
    //   if (!container) {
    //     console.warn(" FlightControl container not found in PoiDetails");
    //     return;
    //   }

    //   container.innerHTML = "";
    //   container.appendChild(buttonElement);
    // },
    stopFlight() {
      this.isFlying = false;
      this.isPaused = false;
      this.$root.$emit("stopFlightControl");
      console.log("Stop to WeatherMTK.vue");
    },
    closeFlight() {
      this.stopFlight(); 
      this.$root.$emit("clearFlightPolyline");
    }

  },
};
</script>

<style scoped>
.poi-header{
  display: flex;
  align-items: center;
  gap: 12px;
  /* 70/30 cu linii fixe */
}

.poi-name{
  flex: 0 1 85%;
  min-width: 0;             
  font-weight: 600;
  /* white-space: nowrap; */
  display: -webkit-box;
  -webkit-line-clamp: 2;     
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  hyphens: manual !important;
}

.poi-actions{
  flex: 0 0 15%;
  display: flex;
  justify-content: flex-end; 
  align-items: center;
  gap: 8px;
}


.action-btn{
  /* display: inline-flex; */
  align-items: center;
  gap: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 3px;
  background: #ecf0f3;
  border: 1px solid #a9a9a9;
  box-shadow: 1px 3px 3px #999999;
  border-radius: 8px;
  cursor: pointer;
  line-height: 1;
  transition: box-shadow .15s ease, transform .05s ease;
}

.action-btn:hover{
  box-shadow: 0 2px 10px rgba(0,0,0,.08);
}

.action-btn:active{
  transform: translateY(1px);
}

.action-icon{
  width: 24px;
  height: 24px;
}

.action-text{
  font-size: 14px;
}


@media (max-width: 520px){
  .action-text{ display: none; }
  .poi-actions{ flex:0 0 20%; gap: 6px; }
}


@media (max-width: 360px){
  .poi-header{
    flex-wrap: wrap;
  }
  .poi-name{
    flex: 1 1 100%;
  }
  .poi-actions{
    flex: 1 1 100%;
    justify-content: flex-start;
  }
}


.flight-control-mount{
  display: contents; 
}

</style>


<style>
body.routing-active #setting-buttons-wrapper {
  display: none !important;
}

body.routing-active .setting-buttons--secondary {
  display: none !important;
}

.mtk-elevation-svg{
  width: 350px;
  height: 100px !important;
}

.mtk-elevation-background{
  height: 120px !important;
  max-height: 120px !important;
}
.mtk-elevation-profile text {
  font-size: 75px !important;
  font-family: Arial, sans-serif !important;
  padding: 2;
  
}

.mtk-elevation-curve-label {
    transform: translateY(-40px) !important;
  font-size: 85px !important;
  fill: #db0c0c;
}


@media (max-width: 768px) {
  .mtk-elevation-svg{
    width: 260px;
  }
}

</style>